<template>
  <div>
    <a :class="['card', 'card-banner', colorClass, bgClass]" :style="imageStyle" v-on:click="emitClick">
      <div class="card-body">
        <i v-if="icon" :class="iconClass"></i>
        <div class="content">
          <div class="title">{{ title }}</div>
          <div class="value">
            <span class="sign" v-if="prefix">{{ prefix }}</span>
            <slot></slot>
            <span v-if="value">{{ value }}</span>
            <span class="sign" v-if="suffix">{{ suffix }}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'blue' // black, green, yellow
    },
    icon: {
      type: String
    },
    value: {},
    title: {
      type: String
    },
    prefix: {
      type: String
    },
    suffix: {
      type: String
    },
    image: {
      type: String
    },
    position: {
      type: String,
      default: 'left'
    }
  },
  computed: {
    iconClass() {
      if (this.icon) {
        return 'icon fa fa-4x fa-' + this.icon;
      }
    },
    imageStyle() {
      if (this.image) {
        return {'background-image': 'url("' + this.image + '")'};
      }
    },
    bgClass() {
      if (this.image) {
        return 'bg-' + this.position;
      }
    },
    colorClass() {
      return 'card-' + this.color + '-light';
    }
  },
  methods: {
    emitClick() {
      this.$emit('click');
    }
  }
}
</script>
